import { render, staticRenderFns } from "./r-bottom-card.vue?vue&type=template&id=06d28f12"
import script from "./r-bottom-card.vue?vue&type=script&lang=js"
export * from "./r-bottom-card.vue?vue&type=script&lang=js"
import style0 from "./r-bottom-card.vue?vue&type=style&index=0&id=06d28f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports